import React from 'react';
import { Upload } from 'antd';
import { greenExcelFile } from '../../../assets/images';
import { SALES_ROLE } from '../../../constants/overview';

const Dragger = Upload.Dragger;

const CustomDragger = ({ title, uploadRequest = () => {}, onUpload, accept = '', classes = '' }) => {
  return (
    <div className={classes}>
      <Dragger name='file' id='dragger' accept={accept} disabled={SALES_ROLE === 'sales'} customRequest={uploadRequest} onChange={onUpload} >
        <div className='py-3 text-center'>
          <h1 className='font-semibold text-base text-gray-700'>{title}</h1>
          <p className='mb-0 text-gray-600 mt-2'>
            Support for a single upload. Strictly prohibit from uploading company data or other files
          </p>
          <img src={greenExcelFile} alt='doc-chat-icon' className='m-auto mt-7' />
          <span className='font-semibold text-gray-600 block mt-4'>Drag and Drop to upload</span>
          <span className='text-gray-600 block mt-1'>
            or <span className='text-blue-600 font-semibold'>Browse</span> to choose a file
          </span>
        </div>
      </Dragger>
    </div>
  );
};

export default CustomDragger;
